import type {
  CollectionUpdateRequestType,
  CollectionUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useCollectionUpdate = (collectionId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: CollectionUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `collection/${collectionId}`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse(response).data as CollectionUpdateResponseType,
      ),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.Collections,
          collectionId,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Collections],
      });
    },
  });
};
